import TrainingMaterial from './TrainingMaterial';

export default TrainingMaterial;
